<app-menu [menu]="menu" activeItemClass="adn-admin-menu-item-active" itemClass="adn-admin-menu-item"></app-menu>
 